import { Outlet } from 'react-router';
import { useUserInfo } from '../../contexts/user-context/use-user-info';
import { Button } from '../../design-system/button/button';
import { Inline } from '../../design-system/inline/inline';
import { SeapointLogo } from '../../design-system/logo/seapoint-logo';

export const SignupPage = () => {
  const { mutations } = useUserInfo();

  return (
    <div className="flex min-h-screen flex-col bg-gray-100">
      <header>
        <Inline justify="between" className="p-4">
          <SeapointLogo />

          <Button onClick={mutations.logout}>Log Out</Button>
        </Inline>
      </header>

      <main className="flex flex-grow items-start justify-center pt-16">
        <div className="w-full max-w-md rounded-lg border-2 border-gray-300 bg-white p-8 shadow-lg">
          <Outlet />
        </div>
      </main>
    </div>
  );
};
